import { AISuggestCategoryProps } from './AISuggestCategory.types';

const userHistory = [
  'userSteuernummerHistory',
  'userIBANHistory',
  'userVATNumbersHistory',
  'userCorrectedMerchantNamesHistory',
  'userEmailHistory',
  'userURLHistory',
  'userVATNumbersHistory',
];

const aggregatedHistory = [
  'aggregatedVATNumbers',
  'aggregatedEmail',
  'aggregatedIBAN',
  'aggregatedValues',
  'aggregatedOCRMerchantNames',
  'aggregatedURL',
  'aggregatedSteuernummers',
];

export const useCategoryReason = (
  formValues: AISuggestCategoryProps['formValues'],
  categoriesDict: Record<string, any>,
) => {
  const { guessed_data, supplier } = formValues;

  const guessedCategoryFrom = guessed_data?.items?.[0]?.guessed_category_from;
  const guessedCategoryId = guessed_data?.items?.[0]?.category_id;

  if (!guessedCategoryFrom || !guessedCategoryId) return null;
  const guessedCategory = categoriesDict[guessedCategoryId];

  const guessTranslationParams = {
    categoryName: guessedCategory?.displayName,
    supplierName: supplier?.name,
  };

  return {
    key: userHistory.includes(guessedCategoryFrom)
      ? 'ai.suggest_category.reason.user_history'
      : aggregatedHistory.includes(guessedCategoryFrom)
      ? 'ai.suggest_category.reason.aggregated_history'
      : 'ai.suggest_category.reason.ocr',
    params: guessTranslationParams,
  };
};
